import * as Yup from "yup";
import fieldFormPeriodoInsc from "./fieldFormPeriodoInsc";

const { startDate, endDay } = fieldFormPeriodoInsc;

const validationPeriodo = Yup.object().shape({
  [startDate.name]: Yup.string().required(startDate.errorMsg),
  [endDay.name]: Yup.string().required(endDay.errorMsg),
});

export { validationPeriodo };
